import API from '@aws-amplify/api';
import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import React, { useEffect, useState } from "react";
import {useSelector, useDispatch} from 'react-redux';
import awsconfig from "./awsconfig";
import { getCookieValue, removeCookie, removeSingleCookie, setCookies } from './cookieHelper';
import allActions from './redux/actions';
import App from './App';
import { useHistory } from 'react-router-dom';
import { tmsProductIds } from './globalConstants';


const Auth = () => {
const history = useHistory(); 
const allInfo = useSelector((state:any) => state);
const dispatch = useDispatch();
const [authComingFromLoginPopup, setAuthComingFromLoginPopup] = useState(false);
const [isAuthenticating, setIsAuthenticating] = useState(true);
const[isChatConfigured, setIsChatConfigured] = useState(false);
let isAuthenticatingLocal = true;
const [stateResult, setStateResult] = useState({});

const setAWSConfig = () => {
  API.configure(awsconfig);
  API.configure({
    API: {
      graphql_endpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT,
      graphql_headers: () => ({
        Authorization: "" + getCookieValue(`${process.env.REACT_APP_ENV}IdToken`) + ""
      })
    }
  })
}
setAWSConfig();
/* Cognito login Implementation */

const AmazonCognitoIdentity = require('amazon-cognito-identity-js');
const CognitoUserPool = AmazonCognitoIdentity.CognitoUserPool;
const jwt = require('jsonwebtoken');
const jwkToPem = require('jwk-to-pem');


const poolData = {
  UserPoolId: process.env.REACT_APP_AWS_USERPOOLID,
  ClientId: process.env.REACT_APP_AWS_CLIENT_ID,
};

const userPool = new CognitoUserPool(poolData);

/*EO Cognito */

interface userCred {
  username: string,
  password: string
}

const jwtValidation = async (resultToken: any, jwk: any) => {
  setIsAuthenticating(true);
  isAuthenticatingLocal = true;
  let tokenFromCookie: string = getCookieValue(`${process.env.REACT_APP_ENV}IdToken`) || "";
  if(tokenFromCookie){
    const resultToken: string  = tokenFromCookie;
    var pem = jwkToPem(jwk);
    const response = {
      message: 'User Signed In Successfully',
      lgId:"0",
      luuId:"0",
      leuId:"0",
      isAuthenticated: true,
    };
    jwt.verify(resultToken, pem, { algorithms: ['RS256'] }, async (err: any, decodedToken: any) => {
      if (decodedToken) {
        setCookies(`${process.env.REACT_APP_COOKIE_POLICY}`, 1);       
        sessionStorage.setItem("lgId", (decodedToken["custom:geId"] || "111111").replace(/\s/g, ''));
        sessionStorage.setItem("luuId", (decodedToken["cognito:username"] || "1-1-1-1-1"));
        sessionStorage.setItem("leuId", (decodedToken["custom:edgeUid"] || "222222"));
        response.lgId = decodedToken["custom:geId"] || "0";
        response.luuId = decodedToken["cognito:username"] || "0";
        response.leuId = decodedToken["custom:edgeUid"] || "0";                    
        setCookies(`${process.env.REACT_APP_ENV}IdToken`, resultToken);
        setCookies(`uId`, response.leuId);
        if(!!!authComingFromLoginPopup){          
          triggerInitAPICache(response.lgId, response.leuId, response.luuId);
        }        
        await dispatch(allActions.commonActions.setUserAuthenticated(true));
        setIsAuthenticating(false);
        isAuthenticatingLocal = false;
        // pushRecordedURL();        
      }
      else { 
        setIsAuthenticating(false);
        isAuthenticatingLocal = false;
        // clearAuthentication();        
        await dispatch(allActions.commonActions.setUserAuthenticationFailReason("JWT_VALIDATION_FAILED"));        
      }
    });
  } else {
    setIsAuthenticating(false);
    isAuthenticatingLocal = false;
      // clearAuthentication();
      await dispatch(allActions.commonActions.setUserAuthenticationFailReason("JWT_VALIDATION_FAILED")); 
  }
}

const getPosition = (mainString: string, subString: string, index: number) => {
  return mainString.split(subString, index).join(subString).length;
}

const redirectWithURL = () => {
  let decodedURL = decodeURIComponent(window.location.href);
  let redURL = decodedURL.slice(decodedURL.indexOf("redirectUrl") + "redirectUrl".length + 1);
  if (redURL.match(/learnship/g)) {
    if (redURL.match(/halo/g)) {       
      const extractedEndURL: string = `${redURL.slice(getPosition(redURL, "/", 3))}` || ""; 
      history.push(extractedEndURL);
      sessionStorage.removeItem("rURL");
      sessionStorage.removeItem("rURLf");
    } else {
      window.location.href = redURL;
    }
  } else {    
    window.location.href = `${window.location.protocol}//${window.location.host}${redURL.slice(getPosition(redURL, "/", 3))}`;
    sessionStorage.removeItem("rURL");
    sessionStorage.removeItem("rURLf");
  }
}

const pushRecordedURL = () => {   
  const redirectToURL: string = sessionStorage.getItem('rURL') || "/"; 
    if (window.location.href !== `${window.location.origin}/`){           
      if(redirectToURL){
        if(window.location.href.search(/redirectUrl/gi) !== -1){
          redirectWithURL();
        } else {
          if(!!sessionStorage.getItem('rURL')){
            sessionStorage.removeItem("rURL");
            sessionStorage.removeItem("rURLf");
          }
        }
      }      
    }   else {
        if(window.location.href.search(/redirectUrl/gi) === -1){
          if(!!sessionStorage.getItem('rURL')){       
            history.push("/");
            sessionStorage.removeItem("rURL");
            sessionStorage.removeItem("rURLf");
          }
        }
    }    
}

const validateJWT = async (resultToken: any) => {
  if(allInfo.jwkPublicKey){
    if(allInfo.jwkPublicKey.data){
      let jwk: any = allInfo.jwkPublicKey.data.keys[0] || "";
      jwtValidation(resultToken, jwk); 
    }  
  }
}

const redirectHandle = (cookieString: string) => {
  if(cookieString){    
    window.location.href = `${process.env.REACT_APP_LOGIN_SVC_URL}/ssologin?token=${cookieString}`;
  }  
}

const checkIfFeatureIsEnabled = (arr: string, featureBitNumber: number) => {
  return !!parseInt(arr[featureBitNumber]);
}

const afterGetLearnerInfo = (resp: any) => {
  if (resp) {    
    if (!checkIfFeatureIsEnabled(resp.data.getpeopleInformation.serviceConfiguration.features, 15)) {          
      // clearAuthentication();  
      sessionStorage.clear();
      const idTokenValue: string = getCookieValue(`${process.env.REACT_APP_ENV}IdToken`) || "";
      removeSingleCookie(`${process.env.REACT_APP_ENV}IdToken`);
      redirectHandle(idTokenValue);      
      // window.location.href = `${process.env["REACT_APP_LOGINURL"]}/`;          
    }
  }
}
const checkIfHalo = () => {
  if(allInfo.peopleInformation && allInfo.peopleInformation.data){
    afterGetLearnerInfo(allInfo.peopleInformation);
  }
};

const checkIfSSOAfter = async (result: any) => {  
  if(allInfo.peopleInformation && allInfo.peopleInformation.data){
    let resp: any = allInfo.peopleInformation;    
    if (resp) {
      if (resp.data.getpeopleInformation.status === "1") {
        if (checkIfFeatureIsEnabled(resp.data.getpeopleInformation.serviceConfiguration.features, 48)){
          validateJWT(result.idToken.jwtToken);
        } else {
          if (checkIfFeatureIsEnabled(resp.data.getpeopleInformation.serviceConfiguration.features, 39)) {
            validateJWT(result.idToken.jwtToken);
          } else {
            // SSO user
            setIsAuthenticating(false);
            isAuthenticatingLocal = false;
            // clearAuthentication();
            await dispatch(allActions.commonActions.setUserAuthenticationFailReason("SSO")); 
          }
        }
      } else {
        // De-activated user(Inactive user)
        setIsAuthenticating(false);
        isAuthenticatingLocal = false;
        // clearAuthentication();
        await dispatch(allActions.commonActions.setUserAuthenticationFailReason("DEACTIVATED")); 
      }
    }
  }
}

const checkIfSSO = async (result: any) => {
  setAWSConfig();  
  if(allInfo.peopleInformation)
  {
    if(allInfo.peopleInformation.data){
      let resp = allInfo.peopleInformation;
      sessionStorage.setItem('pInfo',JSON.stringify(resp));
      checkIfSSOAfter(result);
  }
  }
};

const authenticateInput = (credentials: userCred) => {
  setIsAuthenticating(true);
  isAuthenticatingLocal = true;
  setAuthComingFromLoginPopup(true)
  let authDetails = {
    Username: credentials.username,
    Password: credentials.password,
  };
  const authenticationDetails = new AuthenticationDetails(authDetails);
  const userData = {
    Username: credentials.username,
    Pool: userPool,
  };
  const cognitoUser = new CognitoUser(userData);
  cognitoUser.setAuthenticationFlowType('USER_PASSWORD_AUTH');
  cognitoUser.authenticateUser(authenticationDetails, {
    onSuccess: async function (result: any) {
      setCookies(`${process.env.REACT_APP_ENV}IdToken`, result.idToken.jwtToken);      
      API.configure(awsconfig);
      API.configure({
        API: {
          graphql_endpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT,
          graphql_headers: async () => ({
            Authorization: "" + result.idToken.jwtToken + ""
          })
        }
      })      
      const lgId: string = result.idToken.payload["custom:geId"] || "0";
      const leuId: string = result.idToken.payload["custom:edgeUid"] || "0";
      const luuId: string = result.idToken.payload["cognito:username"] || "0";
      setCookies(`uId`, leuId);
      setIsAuthenticating(false);
      isAuthenticatingLocal = false;
      triggerInitAPICache(lgId,leuId,luuId);
      setStateResult(result)      
    },
    onFailure: async function () {
      setIsAuthenticating(false);
      isAuthenticatingLocal = false;
      // clearAuthentication();
      await dispatch(allActions.commonActions.setUserAuthenticationFailReason("COGNITO_LOGIN_FAILED")); 
    }
  });
}

const clearAuthentication = async (clearRedirectURL?: boolean) => {  
  if(!clearRedirectURL){    
    if(isAuthenticatingLocal){      
      setTimeout(()=>{
        // clearAuthentication(clearRedirectURL);
      },1500);      
    } else {
      if(!!!allInfo.common.isLoading && !!!allInfo.common.isUserAuthenticated && !!!isAuthenticatingLocal){    
        setTimeout(()=>{ 
          let decodedURL = decodeURIComponent(window.location.href);
          let redURL = decodedURL.slice(decodedURL.indexOf("redirectUrl") + "redirectUrl".length + 1);
          if(redURL.indexOf(process.env.REACT_APP_GE_SUPPORT_URL || "") === -1){            
            const apRedURL = sessionStorage.getItem("apRedURL") || "";            
            const encodedURL = `${window.location.origin}/?redirectUrl=${encodeURIComponent(window.location.origin)}${encodeURIComponent(apRedURL || "")}`;
            if(apRedURL && apRedURL !== "/"){
              window.history.replaceState(null, "", encodedURL || "/");
              sessionStorage.removeItem("apRedURL");
            } else {
              window.history.replaceState(null, "", sessionStorage.getItem("rURLf") || "/");
            }
          }
          sessionStorage.removeItem("rURL");
          sessionStorage.removeItem("rURLf");
        },1000);
      }  
    }
  }
  await dispatch(allActions.globalActions.logoutSession());
  await dispatch(allActions.tmsCoursesAction.callTMSLogOut());  
  setStateResult({})
  if(clearRedirectURL){
    sessionStorage.clear();    
  } else {
    let rURLf = sessionStorage.getItem('rURLf') || "";
    let rURL = sessionStorage.getItem('rURL') || "";
    // let apRedURL = sessionStorage.getItem('apRedURL') || "";
    sessionStorage.clear();
    // sessionStorage.setItem("apRedURL", apRedURL);
    sessionStorage.setItem("rURL", rURL);
    sessionStorage.setItem("rURLf", rURLf);    
  }  
  removeCookie();  
  // if(window.Intercom){
  //   window.Intercom('shutdown');
  // }    
}


const triggerInitAPICache = async (lgId: string, leuId: string, luuId: string) => {  
  await dispatch(allActions.commonActions.setUserInitialInformation(lgId,luuId,leuId));
  if(!!!allInfo.peopleInformation.data){
    await dispatch(allActions.peopleInformationActions.getStorePeopleInfo(lgId));
  }
  if(!!!allInfo.learnerTasks.data){
    await dispatch(allActions.learnerTasksAction.getLearnerTasks(leuId));
  }
  if(!!!allInfo.portalLogin.data){
    await dispatch(allActions.portalLoginAction.getPortalLogin(leuId, lgId));
  }
  if(!!!allInfo.jwkPublicKey.data){
    await dispatch(allActions.jwkPublicKeyAction.getJwkPublicKey());
  }
}


const checkAuthOnRefresh = async () => {  
  await dispatch(allActions.jwkPublicKeyAction.getJwkPublicKey());
}

useEffect(() => {
  if (!!!allInfo.jwkPublicKey.isLoading) {
    if (!!!allInfo.jwkPublicKey.isFailed && !!allInfo.jwkPublicKey.data) {
      validateJWT(getCookieValue(`${process.env.REACT_APP_ENV}IdToken`));
    }
  }
}, [allInfo.jwkPublicKey]);

useEffect(()=>{
  checkAuthOnRefresh();
},[])
useEffect(()=>{        
  if(!!!allInfo.common.isLoading &&
    !!!allInfo.peopleInformation.isLoading &&
    !!!allInfo.learnerTasks.isLoading &&
    !!!allInfo.portalLogin.isLoading &&
    !!!allInfo.jwkPublicKey.isLoading){
      if(!!!allInfo.common.isFailed && !!!allInfo.peopleInformation.isFailed && !!!allInfo.learnerTasks.isFailed && !!!allInfo.portalLogin.isFailed && !!!allInfo.jwkPublicKey.isFailed){
        checkIfHalo();
        if(stateResult && Object.keys(stateResult).length > 0)
        {
          checkIfSSO(stateResult);
        }
        //Check to see if TMS calls are required
        if(!!allInfo.peopleInformation.data)
        {
         const {license} = allInfo.peopleInformation.data.getpeopleInformation;
         if(license.length>0 && license[0].isDemoLicense==="1")
         dispatch(allActions.commonActions.setIsTMSRequired(false));
         else
         dispatch(allActions.commonActions.setIsTMSRequired( license.filter((products: { productId: string; active: string; }) => tmsProductIds.includes(products.productId) && products.active==="1").length>0));
        }
      }
     
     
  }    
},[allInfo.common, allInfo.peopleInformation, allInfo.learnerTasks, allInfo.portalLogin, allInfo.jwkPublicKey])

const getLicensesCommaSeperated = (license: Array<any>) => {
  let finalCommaStringArr: any = [];
  if(license && (license.length > 0)){
  license.map((lic, i)=>{
    finalCommaStringArr.push(lic.productName);
  }) 
  return (finalCommaStringArr.length > 0) ? finalCommaStringArr.join(", ") : "";
  }
}

useEffect(()=> {
  if (
    !!!allInfo.peopleInformation.isLoading &&
    !!!allInfo.peopleInformation.isFailed &&
    !!allInfo.peopleInformation.data && !!window.liveagent &&
    !!!isChatConfigured
  ) {
    const { firstName, lastName, email,username, edgeUid, language, country,orgName,accountName, license, accountId} = allInfo.peopleInformation.data.getpeopleInformation;
    const platform = navigator.platform;
    const fullname = `${firstName} ${lastName}`;  
      window.liveagent.addCustomDetail("First Name", firstName).saveToTranscript("First_Name__c");
      window.liveagent.addCustomDetail("User Name", username).saveToTranscript("User_Name__c");
      window.liveagent.addCustomDetail("User Id", edgeUid).saveToTranscript("User_ID__c");
      window.liveagent.addCustomDetail("Operating System", platform).saveToTranscript("Operating_System__c");
      window.liveagent.addCustomDetail("Last Name", lastName).saveToTranscript("Last_Name__c");
      window.liveagent.addCustomDetail("Language", language).saveToTranscript("Language__c");
      window.liveagent.addCustomDetail("Full Name", fullname ).saveToTranscript("Full_Name__c");
      window.liveagent.addCustomDetail("Email", email).saveToTranscript("Email__c");
      window.liveagent.addCustomDetail("Display Name", firstName).saveToTranscript("Display_Name__c");
      window.liveagent.addCustomDetail("Country", country).saveToTranscript("Country__c");
      window.liveagent.addCustomDetail("Company Name", orgName).saveToTranscript("Company_Name__c");
      window.liveagent.addCustomDetail("Account Name", accountName).saveToTranscript("AccountId");
      window.liveagent.addCustomDetail("License Name", getLicensesCommaSeperated(license)).saveToTranscript("License_Name__c");
      window.liveagent.addCustomDetail("GEId", allInfo.common.lgId).saveToTranscript("GEId__c");
      window.liveagent.addCustomDetail("OrgId", accountId).saveToTranscript("OrgId__c");
      window.liveagent.setName(`${firstName} ${lastName}`);
      window.liveagent.init(
        process.env.REACT_APP_INIT_URL,
        process.env.REACT_APP_INIT_CODE_ONE,
        process.env.REACT_APP_INIT_CODE_TWO
      );
      setIsChatConfigured(true);
  }
},[ allInfo.peopleInformation, window.liveagent]);

return <App authenticateInput={authenticateInput} jwtValidation={jwtValidation} clearAuthentication={clearAuthentication} isAuthenticating={isAuthenticating}/>
         
}

export default Auth;
